import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { CategoryPage } from "./category.page";
import { ComponentsModule } from "../components/components.module";
// import { HeaderComponent } from '../../app/header/header.component';

const routes: Routes = [
  {
    path: "",
    component: CategoryPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    RouterModule.forChild(routes),
  ],
  // exports: [HeaderComponent],
  // declarations: [CategoryPage, HeaderComponent]
  declarations: [CategoryPage],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class CategoryPageModule {}
